module.exports = __webpack_public_path__ + "static/media/birds-eye-village-annotated-mobile-cropped2.6b12a385.jpg";